/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис публикации публичных криптографических ключей в формате JWK
 */

/**
 * Сервис JWKS
 */
export class KeyServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения публичного ключа.
   * Используется сервисом KMS.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695357.
   * Метод доступен для: service
   */
  PostKey = (req: PostKeyRequestDto, init?: RequestInit): Promise<PostKeyResponseDto> => {
    return fm.request<PostKeyRequestDto, PostKeyResponseDto>(`${this.host}/jwks/internal/api/v1/key`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления публичного ключа.
   * Используется сервисом KMS.
   * Метод доступен для: service
   */
  DeleteKey = (req: DeleteKeyRequestDto, init?: RequestInit): Promise<DeleteKeyResponseDto> => {
    return fm.request<DeleteKeyRequestDto, DeleteKeyResponseDto>(`${this.host}/jwks/internal/api/v1/key/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения публичных ключей.
   * Возвращает три последних публичных ключа.
   * Используется партнёрами, с помощью публичного ключа проверяется подпись в JWT, выпущенных платформой Ключ.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695865.
   * Не требует авторизации
   */
  GetKeyWellKnownJwksJson = (req?: GetKeyWellKnownJwksJsonRequestDto, init?: RequestInit): Promise<GetKeyWellKnownJwksJsonResponseDto> => {
    return fm.request<GetKeyWellKnownJwksJsonRequestDto, GetKeyWellKnownJwksJsonResponseDto>(`${this.host}/jwks/api/v1/key/.well-known/jwks.json${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос удаления публичного ключа
 */
export type DeleteKeyRequestDto = {
  /**
   * Идентификатор ключа, соответсвует kid.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления публичного ключа
 */
export type DeleteKeyResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteKeyResponseErrorDto
}>
/**
 * Ошибка запроса удаления публичного ключа
 */
export type DeleteKeyResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса удаления публичного ключа
 */
export type DeleteKeyResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на получение публичных ключей
 */
export type GetKeyWellKnownJwksJsonRequestDto = {
}
/**
 * Ответ на запрос на получение публичных ключей
 */
export type GetKeyWellKnownJwksJsonResponseDto = {
  /**
   * Список ключей
   */
  data: KeyInfoPublicKeyResponseDto[]
}
/**
 * Ключ.
 * # Описание модели
 */
export type KeyInfoRequestDto = {
  /**
   * Идентификатор ключа, соответсвует kid.
   * # Тип: Guid
   */
  id: string
  /**
   * Публичный ключ
   */
  publicKey: KeyInfoPublicKeyRequestDto
}
/**
 * Ключ.
 * # Описание модели
 */
export type KeyInfoResponseDto = {
  /**
   * Идентификатор ключа, соответсвует kid.
   * # Тип: Guid
   */
  id: string
  /**
   * Публичный ключ
   */
  publicKey: KeyInfoPublicKeyResponseDto
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
}
/**
 * Публичный ключ
 */
export type KeyInfoPublicKeyRequestDto = {
  /**
   * Вид использования.
   * # Диапазон: 2..32
   */
  use: string
  /**
   * Тип ключа.
   * # Диапазон: 2..32
   */
  kty: string
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  kid: string
  /**
   * Алгоритм шифрования.
   * # Диапазон: 2..32
   */
  alg?: string
  /**
   * Параметр Modulus
   */
  n: string
  /**
   * Параметр Exponent
   */
  e: string
  /**
   * Цепочка сертификатов X.509.
   * # Диапазон: 0..100
   */
  x5c?: string[]
}
/**
 * Публичный ключ
 */
export type KeyInfoPublicKeyResponseDto = {
  /**
   * Вид использования.
   * # Диапазон: 2..32
   */
  use: string
  /**
   * Тип ключа.
   * # Диапазон: 2..32
   */
  kty: string
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  kid: string
  /**
   * Алгоритм шифрования.
   * # Диапазон: 2..32
   */
  alg: string
  /**
   * Параметр Modulus
   */
  n: string
  /**
   * Параметр Exponent
   */
  e: string
  /**
   * Цепочка сертификатов X.509.
   * # Диапазон: 0..100
   */
  x5c: string[]
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type KeyInfoSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ключ с таким идентификатором уже существует
   */
  readonly keyAlreadyExists: KeyInfoSavingErrorKeyAlreadyExistsRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type KeyInfoSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ключ с таким идентификатором уже существует
   */
  readonly keyAlreadyExists: KeyInfoSavingErrorKeyAlreadyExistsResponseDto
}>
/**
 * Ключ с таким идентификатором уже существует.
 * Причины:
 * - В базе хранится запись с переданнм kid
 */
export type KeyInfoSavingErrorKeyAlreadyExistsRequestDto = {
}
/**
 * Ключ с таким идентификатором уже существует.
 * Причины:
 * - В базе хранится запись с переданнм kid
 */
export type KeyInfoSavingErrorKeyAlreadyExistsResponseDto = {
}
/**
 * Запрос на сохранение публичного ключа
 */
export type PostKeyRequestDto = {
  /**
   * Ключ
   */
  data: KeyInfoPublicKeyRequestDto
}
/**
 * Ответ на запрос на сохранение публичного ключа
 */
export type PostKeyResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostKeyResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostKeyResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибки валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: KeyInfoSavingErrorRequestDto
}>
/**
 * Ошибка
 */
export type PostKeyResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибки валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: KeyInfoSavingErrorResponseDto
}>
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления публичного ключа
   */
  "DeleteKeyRequest": {
    "kind": "class",
    "text": "Запрос удаления публичного ключа",
    "fields": {
      /**
       * Идентификатор ключа, соответсвует kid.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор ключа, соответсвует kid.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления публичного ключа
   */
  "DeleteKeyResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления публичного ключа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteKeyResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса удаления публичного ключа
   */
  "DeleteKeyResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса удаления публичного ключа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение публичных ключей
   */
  "GetKeyWellKnownJwksJsonRequest": {
    "kind": "class",
    "text": "Запрос на получение публичных ключей",
  },
  /**
   * Ответ на запрос на получение публичных ключей
   */
  "GetKeyWellKnownJwksJsonResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение публичных ключей",
    "fields": {
      /**
       * Список ключей
       */
      "data": {
        "type": "KeyInfo.PublicKey",
        "text": "Список ключей",
      },
    },
  },
  /**
   * Ключ.
   * # Описание модели
   */
  "KeyInfo": {
    "kind": "class",
    "text": "Ключ.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор ключа, соответсвует kid.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор ключа, соответсвует kid.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Публичный ключ
       */
      "publicKey": {
        "type": "KeyInfo.PublicKey",
        "text": "Публичный ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Публичный ключ
   */
  "KeyInfo.PublicKey": {
    "kind": "class",
    "text": "Публичный ключ",
    "fields": {
      /**
       * Вид использования.
       * # Диапазон: 2..32
       */
      "use": {
        "type": "string",
        "text": "Вид использования.\n# Диапазон: 2..32",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * Тип ключа.
       * # Диапазон: 2..32
       */
      "kty": {
        "type": "string",
        "text": "Тип ключа.\n# Диапазон: 2..32",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "kid": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Алгоритм шифрования.
       * # Диапазон: 2..32
       */
      "alg": {
        "type": "string",
        "text": "Алгоритм шифрования.\n# Диапазон: 2..32",
        "rules": {
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * Параметр Modulus
       */
      "n": {
        "type": "string",
        "text": "Параметр Modulus",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр Exponent
       */
      "e": {
        "type": "string",
        "text": "Параметр Exponent",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Цепочка сертификатов X.509.
       * # Диапазон: 0..100
       */
      "x5c": {
        "type": "string",
        "text": "Цепочка сертификатов X.509.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "KeyInfo.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Ключ с таким идентификатором уже существует
       */
      "keyAlreadyExists": {
        "type": "KeyInfo.SavingError.KeyAlreadyExists",
        "text": "Ключ с таким идентификатором уже существует",
      },
    },
  },
  /**
   * Ключ с таким идентификатором уже существует.
   * Причины:
   * - В базе хранится запись с переданнм kid
   */
  "KeyInfo.SavingError.KeyAlreadyExists": {
    "kind": "class",
    "text": "Ключ с таким идентификатором уже существует.\nПричины:\n- В базе хранится запись с переданнм kid",
  },
  /**
   * Запрос на сохранение публичного ключа
   */
  "PostKeyRequest": {
    "kind": "class",
    "text": "Запрос на сохранение публичного ключа",
    "fields": {
      /**
       * Ключ
       */
      "data": {
        "type": "KeyInfo.PublicKey",
        "text": "Ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на сохранение публичного ключа
   */
  "PostKeyResponse": {
    "kind": "class",
    "text": "Ответ на запрос на сохранение публичного ключа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostKeyResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostKeyResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибки валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибки валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "KeyInfo.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}